// IconComponent.tsx
import React from 'react'

const UserIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="45"
      viewBox="0 0 54 55"
      fill="none"
    >
      <g clipPath="url(#clip0_198_975)">
        <rect
          y="0.525391"
          width="54"
          height="54"
          rx="27"
          fill="url(#paint0_linear_198_975)"
        />
        <path
          d="M37.125 20.7754C37.125 23.4607 36.0583 26.036 34.1595 27.9348C32.2607 29.8337 29.6853 30.9004 27 30.9004C24.3147 30.9004 21.7393 29.8337 19.8405 27.9348C17.9417 26.036 16.875 23.4607 16.875 20.7754C16.875 18.0901 17.9417 15.5147 19.8405 13.6159C21.7393 11.7171 24.3147 10.6504 27 10.6504C29.6853 10.6504 32.2607 11.7171 34.1595 13.6159C36.0583 15.5147 37.125 18.0901 37.125 20.7754Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 27.5254C0 20.3645 2.84464 13.497 7.90812 8.43351C12.9716 3.37003 19.8392 0.525391 27 0.525391C34.1608 0.525391 41.0284 3.37003 46.0919 8.43351C51.1554 13.497 54 20.3645 54 27.5254C54 34.6862 51.1554 41.5538 46.0919 46.6173C41.0284 51.6808 34.1608 54.5254 27 54.5254C19.8392 54.5254 12.9716 51.6808 7.90812 46.6173C2.84464 41.5538 0 34.6862 0 27.5254ZM27 3.90039C22.551 3.90063 18.1925 5.15711 14.4261 7.52523C10.6597 9.89335 7.63858 13.2769 5.71038 17.2863C3.78218 21.2957 3.0253 25.7682 3.52687 30.1888C4.02844 34.6094 5.76805 38.7986 8.5455 42.2741C10.9418 38.4131 16.2169 34.2754 27 34.2754C37.7831 34.2754 43.0549 38.4098 45.4545 42.2741C48.2319 38.7986 49.9716 34.6094 50.4731 30.1888C50.9747 25.7682 50.2178 21.2957 48.2896 17.2863C46.3614 13.2769 43.3403 9.89335 39.5739 7.52523C35.8075 5.15711 31.449 3.90063 27 3.90039Z"
          fill="white"
        />
      </g>
      <rect
        x="0.5"
        y="1.02539"
        width="53"
        height="53"
        rx="26.5"
        stroke="url(#paint1_linear_198_975)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_198_975"
          x1="57.375"
          y1="19.0879"
          x2="8.4375"
          y2="41.0254"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#rgba(15, 153, 238, 1)" />
          <stop
            offset="rgba(15, 153, 238, 1)"
            stopColor="rgba(15, 153, 238, 1)"
          />
          <stop offset="1" stopColor="rgba(15, 153, 238, 1)" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_198_975"
          x1="4.67308"
          y1="14.0254"
          x2="27"
          y2="54.5254"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgba(15, 153, 238, 1)" />
          <stop offset="1" stopColor="rgba(15, 153, 238, 1)" />
        </linearGradient>
        <clipPath id="clip0_198_975">
          <rect y="0.525391" width="54" height="54" rx="27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default UserIcon
